import { KIOSK_STEPS } from '@/constants/routes';
import { Fragment } from 'react';

interface StepProgressProps {
  currentStep: number;
}

/**
 * Renders the "1 Upload — 2 Options — 3 Pay — 4 Release" progress track.
 * Used both compactly in the header (mobile) and expanded on desktop.
 */
export function StepProgress({ currentStep }: StepProgressProps) {
  return (
    <div className="d-flex align-items-center w-100">
      {KIOSK_STEPS.map((step, index) => {
        const isComplete = step.step < currentStep;
        const isActive = step.step === currentStep;
        const isLast = index === KIOSK_STEPS.length - 1;

        return (
          <Fragment key={step.step}>
            <div className="d-flex align-items-center gap-2 flex-shrink-0">
              <span
                className={[
                  'd-flex align-items-center justify-content-center rounded-circle text-label-sm fw-semibold',
                  isActive || isComplete ? 'bg-primary text-white' : 'bg-surface-highest text-on-surface-variant',
                ].join(' ')}
                style={{ width: 24, height: 24, flexShrink: 0 }}
              >
                {isComplete ? <i className="bi bi-check-lg" style={{ fontSize: 14 }} /> : step.step}
              </span>
              <span
                className={[
                  'text-label-sm d-none d-sm-inline',
                  isActive ? 'text-on-surface' : 'text-on-surface-variant',
                ].join(' ')}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                className="flex-grow-1 mx-2 rounded-pill"
                style={{
                  height: 4,
                  backgroundColor: isComplete
                    ? 'var(--kiosk-primary)'
                    : 'var(--kiosk-surface-container-highest)',
                }}
              />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
